import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-block" }
const _hoisted_2 = { class: "block-header" }

import { computed } from "vue";
import type { QuestionType } from "@/services/customQuestionsService";
import TandemTextInput from "@/components/TandemTextInput.vue";
import TandemSelect from "@/components/TandemSelect.vue";
import TandemInputWrapper from "@/components/TandemInputWrapper.vue";
import TaskInput from "@/components/TaskInput.vue";

const MIN_RESPONSE_OPTIONS = 2;
const MAX_RESPONSE_OPTIONS = 15;

export interface FormState {
  id?: number;
  question_text: string;
  question_type: QuestionType;
  response_options: string[];
}

export interface FormErrors {
  question_text?: string[];
  question_type?: string[];
  response_options?: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomQuestionForm',
  props: {
    modelValue: {},
    title: {},
    errors: {}
  },
  emits: ["delete", "update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;

const labels: Record<QuestionType, string> = {
  single: "Single Response",
  multiple: "Multiple Response",
};





const options: QuestionType[] = ["single", "multiple"];

const formData = computed({
  get: () => {
    return props.modelValue;
  },
  set: (value: FormState) => {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("button", {
        class: "btn btn-red",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('delete')), ["prevent"]))
      }, " Delete ")
    ]),
    _createVNode(TandemTextInput, {
      name: "question_text",
      label: "Question Text",
      "help-text": "What do you want to ask students?",
      modelValue: formData.value.question_text,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.question_text) = $event)),
      errors: _ctx.errors?.question_text,
      required: ""
    }, null, 8, ["modelValue", "errors"]),
    _createVNode(TandemSelect, {
      label: "Question Type",
      name: "question_type",
      modelValue: formData.value.question_type,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.question_type) = $event)),
      errors: _ctx.errors?.question_type,
      options: options,
      "get-key": (x) => x,
      "get-label": (x) => labels[x],
      required: ""
    }, null, 8, ["modelValue", "errors", "get-key", "get-label"]),
    _createVNode(TandemInputWrapper, {
      label: "Response Options",
      name: "response_options",
      errors: _ctx.errors?.response_options,
      required: ""
    }, {
      default: _withCtx(() => [
        _createVNode(TaskInput, {
          "min-num-values": MIN_RESPONSE_OPTIONS,
          "max-num-values": MAX_RESPONSE_OPTIONS,
          modelValue: formData.value.response_options,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.response_options) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors"])
  ]))
}
}

})